import React from "react";

import { Checkbox } from "../../../../components/ui/checkbox";

import FotoProduto from "../FotoProduto";

// Produto fora da campanha: só foto e nome. Marcar abre as opções de desconto.
export default function ItemRecolhido({ nome, foto, onMarcar }) {
  return (
    <label data-e2e="linha-oferta" data-recolhido="1"
      className="flex items-center gap-2.5 rounded-lg border p-2 cursor-pointer hover:border-primary/40 hover:bg-muted/40 transition-colors min-w-0">
      <Checkbox checked={false} onCheckedChange={(v) => v && onMarcar()} aria-label={`Participa: ${nome}`} />
      <FotoProduto url={foto} nome={nome} tamanho="w-9 h-9" />
      <span className="text-sm text-muted-foreground leading-tight line-clamp-2">{nome}</span>
    </label>
  );
}
